<template>

  <Head title="Tambah Dokumen" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs :breadcrumbs="[
          { name: 'Dashboard', href: route('dashboard') },
          { name: `Kinerja Program Studi`, href: route('kinerja.index') },
          {
            name: `${instrumens.data[0].instrumen}`,
            href: route('kinerja.adddocument', instrumens.data[0].slugid),
          },
        ]" />
        <div class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">
              {{ instrumens.data[0].instrumen }}
            </h1>
          </div>
          <div class="flex items-center gap-4">
            <p class="text-sm text-gray-500">
              Tambah Dokumen Kinerja /
              {{ instrumens.data[0]?.akreditasi?.akreditasi || "N/A" }}
            </p>
          </div>
        </div>

        <div class="col-span-1 p-4 lg:col-span-2">
          <div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8">
            <div class="h-auto">
              <FormAdd :instrumen="instrumens" :program="programs" />
            </div>
            <div class="h-auto rounded-lg lg:col-span-2">
              <div class="overflow-hidden bg-white border rounded-lg shadow">
                <div class="px-4 py-2 overflow-hidden text-sm font-medium text-gray-900 border-b bg-gray-50">
                  <h1>{{ instrumens.data[0].instrumen }}</h1>
                </div>
                <div class="p-4 overflow-x-auto">
                  <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
                    <div class="flex items-center gap-2">
                      <label class="text-xs font-medium text-gray-600">Cari:</label>
                      <input v-model="localSearch" @keyup.enter="applyFilters" type="text"
                        placeholder="Nama / deskripsi"
                        class="px-2 py-1 text-sm border rounded focus:outline-none focus:ring focus:border-indigo-400" />
                      <button @click="applyFilters"
                        class="px-3 py-1 text-xs font-semibold text-white bg-indigo-600 rounded hover:bg-indigo-700">Cari</button>
                      <button v-if="localSearch" @click="resetFilters"
                        class="px-2 py-1 text-xs text-gray-600 bg-gray-100 border rounded hover:bg-gray-200">Reset</button>
                    </div>
                    <div class="flex items-center gap-2">
                      <label class="text-xs font-medium text-gray-600">Per Page:</label>
                      <select v-model.number="pageSize" @change="applyFilters"
                        class="px-2 py-1 text-xs border rounded focus:outline-none focus:ring focus:border-indigo-400">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                      </select>
                    </div>
                  </div>
                  <table class="w-full table-auto">
                    <thead>
                      <tr class="text-xs font-medium text-left text-gray-500 uppercase">
                        <th class="px-4 py-2">No</th>
                        <th class="px-4 py-2">Nama Dokumen</th>
                        <th class="px-4 py-2">Tipe Dokumen</th>
                        <th class="px-4 py-2">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dokumen, index) in files.data" :key="index" class="border-b hover:bg-gray-50"
                        :data-iddok="dokumen.iddok">
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          {{ index + 1 }}.
                        </td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          {{ dokumen.nama_dok }}
                        </td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          {{ dokumen.jenisdokumen.nama }}
                        </td>
                        <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                          <Link :href="route('kinerja.show', dokumen.iddok)"
                            class="px-2 py-1 text-xs font-semibold text-white bg-blue-500 rounded hover:bg-blue-600">
                          Lihat
                          </Link>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="px-4 py-2 text-sm font-medium text-gray-900 border-t bg-gray-50">
                  <p class="text-sm text-gray-500">
                    Menampilkan
                    <span class="font-semibold text-gray-900">{{ pageCount }}</span>
                    dari
                    <span class="font-semibold text-gray-900">{{ totalDocs }}</span>
                    data dokumen.
                  </p>
                  <div v-if="paginationLinks.length > 3" class="flex flex-wrap items-center gap-1 mt-3">
                    <button v-for="(link, i) in paginationLinks" :key="i" :disabled="!link.url"
                      @click="changePage(link)" v-html="sanitizeLabel(link.label)"
                      class="px-3 py-1 text-xs transition border rounded" :class="[
                        link.active ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white text-gray-700 hover:bg-gray-100',
                        !link.url && !link.active ? 'cursor-not-allowed opacity-40' : ''
                      ]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref, computed, onMounted, nextTick } from "vue";
import { Head, router } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import FormAdd from "@/Components/Kinerja/FormAddDokumen.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";

const props = defineProps({
  instrumens: {
    type: Object,
    required: true,
  },
  files: {
    type: Object,
    required: true,
  },
  programs: {
    type: Object,
    required: true,
  },
  highlight: { type: String, default: null }
});
const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewdokumen = ref(null);
const selectedJenis = ref(null);
const selectedProdi = ref(null);

const editDokumen = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    selectedProdi.value = data.prodis;
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
const editFile = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
// Check if file is an image
function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

// Check if file is a PDF
function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}

// Pagination helpers (compatible with paginator or resource collection)
const pageCount = computed(() => props.files?.data ? props.files.data.length : 0)
const totalDocs = computed(() => {
  if (typeof props.files?.total === 'number') return props.files.total
  if (props.files?.meta?.total) return props.files.meta.total
  return props.files?.data?.length || 0
})
const paginationLinks = computed(() => {
  if (Array.isArray(props.files?.links)) return props.files.links
  if (Array.isArray(props.files?.meta?.links)) return props.files.meta.links
  return []
})

// Filter state
const localSearch = ref((props.filters && props.filters.search) || '')
const pageSize = ref((props.filters && props.filters.per_page) || 10)

const applyFilters = () => {
  router.visit(route('kinerja.adddocument', props.instrumens.data[0].slugid), {
    method: 'get',
    data: {
      search: localSearch.value || undefined,
      per_page: pageSize.value,
    },
    replace: true,
    preserveState: true,
    preserveScroll: true,
  })
}
const resetFilters = () => {
  localSearch.value = ''
  applyFilters()
}
let clearTimer = null
watch(localSearch, (val, old) => {
  if (val === '' && old && old.length > 0) {
    if (clearTimer) clearTimeout(clearTimer)
    clearTimer = setTimeout(() => applyFilters(), 300)
  }
})

const changePage = (link) => {
  if (!link.url || link.active) return
  router.visit(link.url, { preserveScroll: true, preserveState: true, replace: true })
}
const sanitizeLabel = (label) => label
  .replace('&laquo;', '«')
  .replace('&raquo;', '»')
  .replace('Previous', 'Prev')
  .replace('Next', 'Next')

const highlightId = ref(props.highlight)

onMounted(() => {
  if (highlightId.value) {
    nextTick(() => {
      const row = document.querySelector(`[data-iddok="${highlightId.value}"]`)
      if (row) {
        row.classList.add('animate-highlight')
        row.scrollIntoView({ behavior: 'smooth', block: 'center' })
        setTimeout(() => row.classList.remove('animate-highlight'), 4000)
      }
    })
  }
})
</script>
<style scoped>
@keyframes flashHighlight {
  0% {
    background-color: #fef3c7;
  }

  50% {
    background-color: #fde68a;
  }

  100% {
    background-color: transparent;
  }
}

.animate-highlight {
  animation: flashHighlight 2.5s ease-in-out 1;
}
</style>
